import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonPrintIcon } from "components/ButtonPrintIcon/ButtonPrintIcon";
import { Toast } from "components/ToastShow/ToastAlert";
import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { MessageType } from "types/enum";
import { ICON_TYPE } from "utils/constants";
import { GetReportWithJsonData, trans } from "utils/helpers";
import "./style.scss";

interface ModalFormProp {
  title: string;
  mode?: string;
  modalProfileKey?: string;
  onHide: () => void;
  show: boolean;
  children?: React.ReactNode | any;
  modalWidth?;
  modalHeight?;
  checkClose?;
  getModalWidth?: (param: any) => void;
  useChangingHeaderFun?: boolean;
  buttonPrintObj?: any;
  openFullscreen?: any;
  forcibleForm?: boolean;
  PriorityAboveMenu?: boolean;
}
export const UserContext = createContext<any>([]);

export const ModalForm = ({
  title,
  mode,
  modalProfileKey,
  onHide,
  show,
  children,
  modalWidth,
  checkClose = true,
  modalHeight ,
  getModalWidth,
  useChangingHeaderFun = false,
  buttonPrintObj,
  openFullscreen = false,
  PriorityAboveMenu = false,
  forcibleForm = false, //when we have a form that we dont use close button or cancle button then use should fill form
}: ModalFormProp) => {
  const [height, setHeight] = useState<number>(window.innerHeight);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [leftx, setLeftx] = useState<any>("5%");
  const [boxWidth, setBoxWidth] = useState<any>(70);
  const [boxHeight, setBoxHeight] = useState<any>(modalHeight?modalHeight:'auto');
  const [fullscreen, setfullscreen] = useState<boolean>(openFullscreen);
  const [mouseleftx, setMouseleftx] = useState<any>();
  const [boxleftx, setBoxleftx] = useState<any>();
  const [mouseleftY, setMouseleftY] = useState<any>();
  const initialHeight=useRef<any>(null)
  const [boxleftY, setBoxleftY] = useState<any>();
  const controlFlag=useRef<any>(false)
  const [readLocalStorage,setReadLocalStorage]=useState(false)
  const [activeIndex, setActiveIndex] = useState<any>(null);
  const [topy, setTopy] = useState<any>("5%");
  const [touchX, setTouchX] = useState<any>();
  const [touchY, setTouchY] = useState<any>();
  const [touchIndex, setTouchIndex] = useState<any>(null);
  const [sendSize, setSendSize] = useState<any>(
    modalWidth < 50 || window.innerWidth < 900
  );
  const [getflag, setgetFlag] = useState<any>(true);
  const [userMadeChanges, setUserMadeChanges] = useState(false);
  const myStateRef = React.useRef(userMadeChanges);
  const boxWidthRef = React.useRef(boxWidth);
  const boxHeightRef = React.useRef(boxHeight);
  const [breakPoint,setBreakPoint]=useState<any>('')
  const hasConditionFormList = [
    "SalesContractForm",
    "SalesInvoiceForm",
    "SalesOrderForm",
    "SalesPreInvoiceForm",
    "SalesReturnInvoiceForm",
  ];
  let disableDrag: boolean = false;
  const lang = localStorage.getItem("DefaultLanguage");
  const el = document.getElementById("modalform");
  const boxRef = useRef<any>();
  const timeID = new Date().getTime() + "modalform";
  const timeIDRes = useRef<any>(timeID);
  const ref = useRef<any>();
// let childrenWithProps
// if(Array.isArray(children)){
//   childrenWithProps = children.map(child =>
//  {
// if (!React.isValidElement(child)) return child
// else{
//   return  React.cloneElement(child, {...child?.props as any, breakPoint })
// }

//  }
//   );
// }else{
// childrenWithProps=React.cloneElement(children, {...children?.props as any, breakPoint })
// }

  window.onresize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  function hide() {
    if (
      sessionStorage.getItem("changingforms") + "" == "true" &&
      checkClose &&
      mode != "view"
    ) {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        onHide();
      });
    } else {
      onHide();
    }
  }

  useEffect(() => {
    return () => {
      let modalKey = modalProfileKey ? modalProfileKey : title;
      let modalsSize = localStorage.getItem("modalsSizeAndPosition");
      let locallist;
      let localflag = true;
      if (modalsSize == null) {
        locallist = [];
               } else {
        locallist = JSON.parse(modalsSize);
      }
      locallist.forEach((item) => {
        if (item[0] == modalKey) {
          localflag = false;
          item[1] = boxWidthRef.current;
          item[2] = boxHeightRef.current;
        }
      });
      if (localflag) {
        locallist.push([modalKey, boxWidthRef.current, boxHeightRef.current]);
      }
      localStorage.setItem("modalsSizeAndPosition", JSON.stringify(locallist));
    };
  }, []);
  const setModalFullscreen = () => {
   if(!fullscreen){
      boxHeightRef.current=100
      boxWidthRef.current=100 
    }else{
      if(boxHeight==100 && boxWidth==100){
        setBoxHeight(40)
        setBoxWidth(70)
        getBootstrapBreakpoint(70)
         boxHeightRef.current=40
         boxWidthRef.current=70
      }
    }
    setfullscreen(!fullscreen);
  };

  // on touch or mouse click

  const mouseDown = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;
    setMouseleftx(e.screenX);
    setBoxleftx(x);
    const y = boxRef?.current?.offsetTop;
    setMouseleftY(e.screenY);
    setBoxleftY(y);
    setActiveIndex(1);
  };

  const touchStart = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;
    setTouchX(e.touches[0].screenX);
    setBoxleftx(x);
    const y = boxRef?.current?.offsetTop;
    setTouchY(e.touches[0].screenY);
    setBoxleftY(y);
    setTouchIndex(1);
  };

  // resize UP & DOWN

  const resizeUp = (e) => {
    e.stopPropagation();
    setReadLocalStorage(true)
    const y = boxRef?.current?.offsetTop;
    setBoxleftY(y);
    setMouseleftY(e.screenY);
    setActiveIndex(4);
  };

  const resizeDown = (e) => {
    e.stopPropagation();
    setReadLocalStorage(true)
    const y = boxRef?.current?.offsetTop;
    setBoxleftY(y);
    setMouseleftY(e.screenY);
    setActiveIndex(5);
  };

  // resize LEFT & RIGHT

  const resizeLeft = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;

    setBoxleftx(x);
    setMouseleftx(e.screenX);
    setActiveIndex(2);
  };

  const resizeRight = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;

    setBoxleftx(x);
    setMouseleftx(e.screenX);
    setActiveIndex(3);
  };

  const resizeTouchRight = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;

    setBoxleftx(x);
    setTouchX(e.touches[0].screenX);
    setTouchIndex(3);
  };

  const resizeTouchLeft = (e) => {
    e.stopPropagation();
    const x = boxRef?.current?.offsetLeft;

    setBoxleftx(x);
    setTouchX(e.touches[0].screenX);
    setTouchIndex(2);
  };

  // if any text selected

  const textSelection = () => {
    const selection = document.getSelection();
    const selectonRange: any = selection?.focusOffset;

    if (selectonRange > 0) {
      disableDrag = true;
    } else {
      disableDrag = false;
    }
  };




// breakPoint تشخیص
    function getBootstrapBreakpoint(width) {
    width=(window.innerWidth*width)/100
    if (width < 576)  {setBreakPoint(''); return };
    if (width < 768)  {setBreakPoint('sm'); return };
    if (width < 992)  {setBreakPoint('md'); return };
    if (width < 1200) {setBreakPoint('lg'); return };
    if (width < 1400) {setBreakPoint('xl'); return };
    if(width >= 1400) {setBreakPoint('xxl'); return };
  }

  // mouse and touch travel on screen

  const mouseMove = useCallback(
    (e) => {

// مثال استفاده
if(!initialHeight.current){
  initialHeight.current=boxRef.current?.getBoundingClientRect().height
}

const percent =boxHeight=='auto'? initialHeight.current:boxHeight

      if (disableDrag) {
        e.preventDefault();
        return;
      } else if (activeIndex == 1) {
        setLeftx(boxleftx - (mouseleftx - e.screenX) + "px");
        if (e.clientY > 5) {
          setTopy(boxleftY - (mouseleftY - e.screenY) + "px");
        }
      } else if (activeIndex == 2) {
        if (mouseleftx - e.screenX < 420) {
          if (
            mouseleftx - e.screenX + (boxWidth * window.innerWidth) / 100 >
            450
          ) {
            setLeftx(boxleftx - (mouseleftx - e.screenX) + "px");
            setBoxWidth(
              ((mouseleftx - e.screenX) / window.innerWidth) * 100 + boxWidth
            );
            getBootstrapBreakpoint(  ((mouseleftx - e.screenX) / window.innerWidth) * 100 + boxWidth)
            boxWidthRef.current =
              ((mouseleftx - e.screenX) / window.innerWidth) * 100 + boxWidth;
          }
        }
      } else if (activeIndex == 3) {
        if (mouseleftx - e.screenX < 420) {
          if (
            (boxWidth * window.innerWidth) / 100 - (mouseleftx - e.screenX) >
            450
          ) {
            setBoxWidth(
              boxWidth - ((mouseleftx - e.screenX) / window.innerWidth) * 100
            );
            getBootstrapBreakpoint( boxWidth - ((mouseleftx - e.screenX) / window.innerWidth) * 100)
            boxWidthRef.current =
              boxWidth - ((mouseleftx - e.screenX) / window.innerWidth) * 100;
          }
        }
      } else if (activeIndex == 4) {
        if(boxHeight=='auto'){
  if (
          percent + (mouseleftY - e.screenY) >
          300
        ) {
          setTopy(boxleftY - (mouseleftY - e.screenY) + "px");
          setBoxHeight(
            (((mouseleftY - e.screenY) / window.innerHeight) * 100) +( (percent/window.innerHeight)*100)
          );
          boxHeightRef.current =
              (((mouseleftY - e.screenY) / window.innerHeight) * 100) +( (percent/window.innerHeight)*100)
        }
        }else{
        if (
          (percent * window.innerHeight) / 100 + (mouseleftY - e.screenY) >
          300
        ) {
          setTopy(boxleftY - (mouseleftY - e.screenY) + "px");
          setBoxHeight(
            ((mouseleftY - e.screenY) / window.innerHeight) * 100 + percent
          );
          boxHeightRef.current =
            ((mouseleftY - e.screenY) / window.innerHeight) * 100 + percent;
        }
        }
      } else if (activeIndex == 5) { 
        if(boxHeight=='auto'){
           if (
          percent  - (mouseleftY - e.screenY) >
          300
        ) {

          setBoxHeight(
            ((percent / window.innerHeight) * 100)-(((mouseleftY - e.screenY )/ window.innerHeight) * 100)) 
       
          boxHeightRef.current =
       ((percent / window.innerHeight) * 100)-(((mouseleftY - e.screenY) / window.innerHeight) * 100)
        }
        }else{
 if (
          (percent * window.innerHeight) / 100 - (mouseleftY - e.screenY) >
          300
        ) {
          setBoxHeight(
            percent - ((mouseleftY - e.screenY) / window.innerHeight) * 100
          );
          boxHeightRef.current =
            percent - ((mouseleftY - e.screenY) / window.innerHeight) * 100;
        }
        }
      }
    },
    [activeIndex]
  );

  const touchMove = useCallback(
    (e) => {
      if (disableDrag) {
        e.preventDefault();
        return;
      } else if (touchIndex == 1) {
        setLeftx(boxleftx - (touchX - e.touches[0].screenX) + "px");
        setTopy(boxleftY - (touchY - e.touches[0].screenY) + "px");
      } else if (touchIndex == 2) {
        setLeftx(boxleftx - (touchX - e.touches[0].screenX) + "px");
        setBoxWidth(
          ((touchX - e.touches[0].screenX) / window.innerWidth) * 100 + boxWidth
        );
        getBootstrapBreakpoint(  ((touchX - e.touches[0].screenX) / window.innerWidth) * 100 + boxWidth)
        boxWidthRef.current =
          ((touchX - e.touches[0].screenX) / window.innerWidth) * 100 +
          boxWidth;
      } else if (touchIndex == 3) {
        setBoxWidth(
          boxWidth - ((touchX - e.touches[0].screenX) / window.innerWidth) * 100
        );
        getBootstrapBreakpoint(boxWidth - ((touchX - e.touches[0].screenX) / window.innerWidth) * 100)
        boxWidthRef.current =
          boxWidth -
          ((touchX - e.touches[0].screenX) / window.innerWidth) * 100;
      }
    },
    [touchIndex]
  );

  // remove events

  const removeListeners = useCallback(() => {
    setActiveIndex(null);
    setBoxleftY(null);
    setMouseleftY(null);
    setBoxleftx(null);
    setMouseleftx(null);
    setTouchY(null);
    setTouchX(null);

    window.removeEventListener("mousemove", mouseMove);
    window.removeEventListener("mouseup", removeListeners, true);
    window.removeEventListener("mouseup", mouseUp);
  }, [mouseMove, touchMove]);

  const removeTouchListeners = useCallback(() => {
    setTouchIndex(null);
    setBoxleftY(null);
    setTouchY(null);
    setBoxleftx(null);
    setTouchX(null);
    setMouseleftY(null);
    setMouseleftx(null);

    el!.removeEventListener("touchmove", touchMove);
    el!.removeEventListener("touchend", removeTouchListeners);
  }, [touchMove, mouseMove]);

  // mouse and touch removed from screen

  const mouseUp = useCallback(() => {
    setActiveIndex(null);
    removeListeners();
  }, [setActiveIndex, removeListeners]);

  const touchEnd = useCallback(() => {
    setTouchIndex(null);
    removeTouchListeners();
  }, [setTouchIndex, removeTouchListeners]);

  useEffect(() => {
    if (activeIndex !== null) {
      window.addEventListener("mousemove", mouseMove);
      window.addEventListener("mouseup", mouseUp);
    }
  }, [mouseDown]);

  useEffect(() => {
    if (touchIndex !== null) {
      el?.addEventListener("touchmove", touchMove);
      el?.addEventListener("touchend", touchEnd);
    }
  }, [touchMove]);

  useEffect(() => {
    if (getflag) {
      getModalWidth && getModalWidth(sendSize);
      let modalKey = modalProfileKey ? modalProfileKey : title;

      let modalsSize = localStorage.getItem("modalsSizeAndPosition");
      let locallist;

      if (modalsSize == null) {
        locallist = [];
        setReadLocalStorage(false)
      } else {
        locallist = JSON.parse(modalsSize);
      }
      locallist.forEach((item) => {
        if (item[0] == modalKey) {
          if(item?.[1]==100 && item?.[2]==100){
            setfullscreen(true)
          }
          setBoxWidth(item[1]);
          getBootstrapBreakpoint(item[1])
          boxWidthRef.current = item[1];
          setBoxHeight(item[2]);
          boxHeightRef.current = item[2];
        }
      });

        if(locallist.some((item) => item[0] == modalKey)){
          setReadLocalStorage(true)

  }else{
          setReadLocalStorage(false)

  }
    }
    setgetFlag(false);
  }, [children]);

  useEffect(() => {
    if (sendSize != (boxWidth < 50 || window.innerWidth < 900)) {
      getModalWidth && getModalWidth(!sendSize);
      setSendSize(!sendSize);
    }
  }, [boxWidth, width]);

  const kydown = (event) => {
    ///////////////////////////////////////////////////////
    //این کد جهت جلوگیری از رسیدن control+c به لایه پشت مدال هست.
    if(event.key=='Control'){  
      if(!controlFlag.current){controlFlag.current=true}  
    }

    if(event.keyCode==67 && controlFlag.current){
      event.stopPropagation();
      }
///////////////////////////////////////////
    if(event.keyCode==35 || event.keyCode==36 || event.keyCode== 34 || event.keyCode==33){
        event.stopPropagation();
}
    if (
      event.key != "Enter" &&
      event.code != "Space" &&
      event.code != "ArrowUp" &&
      event.code != "ArrowDown" &&
      event.code == "Tab" &&
      event.code != "ControlLeft"
    ) {
      if (!event.ctrlKey && !event.code.includes("F")) {
        event.stopPropagation();
      }
    }
    if (
      event.key == "Escape" &&
      !document.activeElement?.className.includes("input")
    ) {
      event.preventDefault();
      event.stopPropagation();

      let modalList = document.getElementsByClassName("modal-form");
      if (modalList.length == 1) {
        document.removeEventListener("keydown", kydown, true);
        hide();
      } else {
        if (
          modalList[modalList?.length - 1] != undefined &&
          modalList[modalList?.length - 1]?.id == timeIDRes.current
        ) {
          hide();
        }
      }
    }
  };
  const getDataForPrintAsync = async (id, dataFromConditionForm = null) => {

    if (buttonPrintObj?.Id) {
      if (id?.includes("Design")) {
      
        const res = await buttonPrintObj.apiFunction(
          buttonPrintObj?.Id,
          buttonPrintObj.params,
          // hasConditionFormList.some(item=>buttonPrintObj.objectTag==item)?dataFromConditionForm:undefined
          dataFromConditionForm
        );

        if (dataFromConditionForm) {
          GetReportWithJsonData(
            id.replace("Design", ""),
            { ...res.Data, PrintSettings: dataFromConditionForm },
            2
          );
        } else {
          GetReportWithJsonData(id.replace("Design", ""), res.Data, 2);
        }
      } else if (id?.includes("Default")) {
        const res = await buttonPrintObj.apiFunction(
          buttonPrintObj?.Id,
          buttonPrintObj.params,
          //hasConditionFormList.some(item=>buttonPrintObj.objectTag==item)?dataFromConditionForm:undefined
          dataFromConditionForm
        );
        GetReportWithJsonData(id.replace("Default", ""), res?.Data, 2);
      } else {
        const res = await buttonPrintObj.apiFunction(
          buttonPrintObj?.Id,
          buttonPrintObj.params,
         // hasConditionFormList.some(item=>buttonPrintObj.objectTag==item)?dataFromConditionForm:undefined
         dataFromConditionForm
        );

        if (dataFromConditionForm) {
          GetReportWithJsonData(
            id,
            { ...res.Data, PrintSettings: dataFromConditionForm },
            1
          );
        } else {
          GetReportWithJsonData(id, res.Data, 1);
        }
      }
    }
    try {
    } catch (error) {}
  };
  // ** stop scrolling window when modal is opened
  useEffect(() => {
    const body: HTMLBodyElement | null = document.querySelector("body");
    body!.style.overflow = "hidden";
    document.addEventListener("keydown", kydown, true);
    if (window.innerWidth < 900) {
      setfullscreen(true);
    }
    return () => {
      document.removeEventListener("keydown", kydown, true);
      body!.style.overflow = "auto";
    };
  }, []);

  useEffect(()=>{
    if(modalHeight){
      setReadLocalStorage(true)
    }
  },[modalHeight])

  useEffect(() => {
    try {
      const modalElement = boxRef.current;
      const firstElement = modalElement.querySelectorAll(".tabStart")[0];
      firstElement.focus();
      const handleTabKeyPress = (event) => {
        if (event.key === "Tab") {
          if (document.activeElement?.className.includes("tab")) {
            let lastElement =
              modalElement.querySelectorAll(".tabEnd ")[
                modalElement.querySelectorAll(".tabEnd").length - 1
              ];
            if (
              event.shiftKey &&
              document.activeElement?.className.includes("tabStart")
            ) {
              event.preventDefault();
              lastElement?.focus();
            } else if (
              !event.shiftKey &&
              lastElement == document.activeElement
            ) {
              event.preventDefault();
              firstElement?.focus();
            }
          }
        }
      };
      modalElement.addEventListener("keydown", handleTabKeyPress);
      return () => {
        modalElement.removeEventListener("keydown", handleTabKeyPress);
      };
    } catch (error) {}
  }, []);

  const textChange = (title) => {
    var regex = /[\u0600-\u06FF]+/;
    var numRegex = /\d+/g;

    let text = "";
    title.split("/").forEach((item: any, index) => {
      if (regex.test(item as any)) {
        text +=
          item +
          (index == title.split("/").length - 1
            ? mode == "create"
              ? "/"
              : ""
            : "/");
      } else {
        text +=
          '<div style="direction: ltr;unicodeBidi:unset;display:inline">' +
          item +
          "</div>" +
          (index == title.split("/").length - 1
            ? mode == "create"
              ? "/"
              : ""
            : "/");
      }
    });
    title = text;
    return title.replaceAll(/\d+/g, (i) => {
      return `<div style="direction: ltr;unicodeBidi:unset;display:inline">  ${i} </div>`;
    });
  };

  return (
    <>
      {show && (
        <>
          <div
            className={`fullscreen-bg-modal ${
              PriorityAboveMenu && "changePassword"
            }`}
          />
          <div
            ref={boxRef}
            id={timeIDRes.current}
            className={`modal-form  ${fullscreen ? "fullscreen-active" : ""}`}
            style={{
              top: topy,
              left: leftx,
              maxHeight: "93%",
             height: `${readLocalStorage?boxHeight+'%':'auto'}`,
             minHeight:`${!readLocalStorage ?'300px':''}`,
              width: `${width < 775 ? 99 : boxWidth}%`,


  //  width: `${width < 775 ? 99 : 
  //                boxWidth==(layoutContext.sidebarIsOpen?80:100-((100*35)/(document.querySelector('#root') as any).clientWidth))
                
                
  //               ?(layoutContext.sidebarIsOpen?80:boxWidth-((100*35)/(document.querySelector('#root') as any).clientWidth)):boxWidth}%`,
  //             minWidth:`${fullscreen ?
  //                boxWidth==(layoutContext.sidebarIsOpen?80:100-((100*35)/(document.querySelector('#root') as any).clientWidth))?(layoutContext.sidebarIsOpen?boxWidth-20:boxWidth-((100*35)/(document.querySelector('#root') as any).clientWidth)):boxWidth : ""}%`

            }}
            role="document"
          >
            <div
              className={`modal-form__resize-right ${
                fullscreen ? "d-none" : "d-block"
              }`}
              onMouseDown={lang === "fa" ? resizeRight : resizeLeft}
              onTouchStart={lang === "fa" ? resizeTouchRight : resizeTouchLeft}
            />
            <div
              className={`modal-form__resize-up ${
                fullscreen ? "d-none" : "d-block"
              }`}
              onMouseDown={resizeUp}
            />
            <div className="modal-form__content modal-content">
              <div
                className="modal-form__content-header modal-header alert-primary"
                onMouseDown={mouseDown}
                onTouchStart={touchStart}
              >
                <strong
                  ref={ref}
                  className="Modaltitle d-flex"
                  id="modal-form__title"
                  dir="rtl"
                  style={{
                    direction: "rtl",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: useChangingHeaderFun
                      ? (textChange(title) as any)
                      : trans(title),
                  }}
                ></strong>
                <div className="d-flex h-100 align-items-center">
                  {buttonPrintObj && (
                    <div 
                      onMouseDown={(e)=>{e.stopPropagation()}}
                      onTouchStart={(e)=>{e.stopPropagation()}}>
                      <ButtonPrintIcon
                        customBtn={true}
                        // openPrintFormatCondition={hasConditionFormList.some(
                        //   (item) => buttonPrintObj.objectTag == item
                        // )}
                        openPrintFormatCondition={true}
                        reportDomain={buttonPrintObj.reportDomain}
                        objectTag={buttonPrintObj.objectTag}
                        Callback={(e, dataFromConditionForm) => {
                          getDataForPrintAsync(e, dataFromConditionForm);
                        }}
                      />
                    </div>
                  )}

                  <div className="me-4 h-100 d-flex align-items-center">
                    {window.innerWidth < 500 ? (
                      <></>
                    ) : (
                      <FontAwesomeIcon
                        icon={
                          fullscreen
                            ? [ICON_TYPE, "compress"]
                            : [ICON_TYPE, "expand"]
                        }
                        onClick={setModalFullscreen}
                        className="modal-form__content-header-fullscreen-btn mx-4 modalForm__fullscreen-btn"
                      />
                    )}
                  </div>

                  {!forcibleForm ? (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        hide();
                      }}
                      type="button"
                      className="ps-3 mt-1 modal-form__content-header-close-btn border-none alert-primary"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
                {/* { buttonPrintObj &&   <ButtonPrintIcon customBtn={true} reportDomain={buttonPrintObj.reportDomain}  objectTag={buttonPrintObj.objectTag} Callback={(e) => {getDataForPrintAsync(e)}} />} */}
              </div>

              <div
                className={`modal-form__content-body modal-body ${
                  fullscreen ? "fullscreen-active" : ""
                } px-2 py-2`}
              >
                <UserContext.Provider
                  value={[
                    userMadeChanges,
                    (e) => {
                      myStateRef.current = e;
                      setUserMadeChanges(e);
                    },
                  ]}
                >
                  {children}
                </UserContext.Provider>
              </div>
            </div>

            {/* <div 
                 className={`modal-form__resize-north-west ${fullscreen ? "d-none" : "d-block"}`}
              />
              <div 
                 className={`modal-form__resize-south-west ${fullscreen ? "d-none" : "d-block"}`}
              /> */}
            <div
              className={`modal-form__resize-down ${
                fullscreen ? "d-none" : "d-block"
              }`}
              onMouseDown={resizeDown}
            />
            <div
              className={`modal-form__resize-left ${
                fullscreen ? "d-none" : "d-block"
              }`}
              onMouseDown={lang === "fa" ? resizeLeft : resizeRight}
              onTouchStart={lang === "fa" ? resizeTouchLeft : resizeTouchRight}
            />
          </div>
        </>
      )}
    </>
  );
};
